/* tslint:disable:indent */
import {HttpClient} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
// import {ServerResponse} from '../interfaces/ServerResponse';
import {map} from 'rxjs/operators';
import {StringFunctions} from '../functions/string-functions';
// import {ServerError} from '../models/server-error.model';
import {API_ENDPOINTS} from '../api/api-endpoints';
import {Website} from '../models/website.model';
import {WhmcsClient, WhmcsClientDetails} from '../models/whmcs-client.model';
import {UptimeRobotMonitor} from '../models/uptime-robot.model';

@Injectable({providedIn: 'root'})
export class UptimeRobotService {
	getMonitors(): Observable<UptimeRobotMonitor[]> { // alt: getMonitors(days: number) where days would be 7-30-45 representing the period for uptime percentage
		return this.http.post(
			API_ENDPOINTS.MONITORING.GET_SERVER_UPTIME,
			{}
			)
			.pipe(
				map((response: any) => {
					if (!response.error) {
						return this.toUptimeRobotMonitorArray(response.message);
					} else {
						return [];
					}
				})
			);
	}

	private toUptimeRobotMonitorArray(data): UptimeRobotMonitor[] {
		const monitors: UptimeRobotMonitor[] = [];
		for (const item of data) {
			monitors.push(
				new UptimeRobotMonitor(
					parseInt(item.id, 10),
					StringFunctions.emptyToNull(item.friendly_name),
					StringFunctions.emptyToNull(item.url),
					parseInt(item.interval, 10),
					parseInt(item.status, 10),
					parseFloat(item.custom_uptime_ratio)
				)
			);
		}
		return monitors;
	}

	constructor(private http: HttpClient) { }
}
